import { EventEmitter, Component, ViewEncapsulation, ViewChildren, Output, Input, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/angular7-pincode.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from '@angular/forms';

const _c0 = ["otpInput"];
function Angular7PincodeComponent_input_1_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "input", 2, 3);
    ɵngcc0.ɵɵlistener("ngModelChange", function Angular7PincodeComponent_input_1_Template_input_ngModelChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r5); const i_r2 = ctx.index; const ctx_r4 = ɵngcc0.ɵɵnextContext(); return (ctx_r4.Pin[i_r2] = $event); })("keyup", function Angular7PincodeComponent_input_1_Template_input_keyup_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r5); const i_r2 = ctx.index; const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.onKeyUp($event, i_r2); })("keydown", function Angular7PincodeComponent_input_1_Template_input_keydown_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r5); const i_r2 = ctx.index; const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.onKeyDown($event, i_r2); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r2 = ctx.index;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMapInterpolate1("otp-input ", ctx_r0.class, "");
    ɵngcc0.ɵɵpropertyInterpolate1("id", "otpInput", i_r2, "");
    ɵngcc0.ɵɵpropertyInterpolate1("name", "otpInput", i_r2, "");
    ɵngcc0.ɵɵproperty("ngModel", ctx_r0.Pin[i_r2])("disabled", ctx_r0.currentIndex != i_r2);
} }
class Angular7PincodeComponent {
    constructor() {
        this.onFullFill = new EventEmitter();
        this.size = 4;
        this.class = "";
        this.Pin = [];
        this.PinCode = "";
        this.currentIndex = 0;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.GetPin();
    }
    /**
     * @return {?}
     */
    GetPin() {
        for (let i = 0; i < this.size; i++) {
            this.Pin.push("");
        }
    }
    /**
     * @param {?} event
     * @param {?} index
     * @return {?}
     */
    onKeyUp(event, index) {
        /** @type {?} */
        let key = event.keyCode || event.which;
        if (event.key !== 'Enter' && key !== 8 && index != this.size - 1) {
            this.currentIndex = index + 1;
            setTimeout((/**
             * @return {?}
             */
            () => {
                this.allOtpInputs.toArray()[index + 1].nativeElement.focus();
            }), 10);
        }
        setTimeout((/**
         * @return {?}
         */
        () => {
            this.PinCode = this.Pin.join('');
            if (this.PinCode.length == this.size) {
                this.onFullFill.emit(this.PinCode);
            }
        }));
    }
    /**
     * @param {?} event
     * @param {?} index
     * @return {?}
     */
    onKeyDown(event, index) {
        /** @type {?} */
        let key = event.keyCode || event.which;
        if (event.key !== 'Enter' && key === 8 && index != 0) {
            setTimeout((/**
             * @return {?}
             */
            () => {
                this.currentIndex = index - 1;
            }), 10);
            setTimeout((/**
             * @return {?}
             */
            () => {
                this.allOtpInputs.toArray()[index - 1].nativeElement.focus();
            }), 100);
        }
    }
    /**
     * @param {?} index
     * @return {?}
     */
    trackByFn(index) {
        return index;
    }
}
Angular7PincodeComponent.ɵfac = function Angular7PincodeComponent_Factory(t) { return new (t || Angular7PincodeComponent)(); };
Angular7PincodeComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: Angular7PincodeComponent, selectors: [["angular7-pincode"]], viewQuery: function Angular7PincodeComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, true);
    } if (rf & 2) {
        var _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.allOtpInputs = _t);
    } }, inputs: { size: "size", class: "class" }, outputs: { onFullFill: "onFullFill" }, decls: 2, vars: 2, consts: [[1, "otp-container"], ["autocomplete", "off", "maxlength", "1", 3, "class", "id", "name", "ngModel", "disabled", "ngModelChange", "keyup", "keydown", 4, "ngFor", "ngForOf", "ngForTrackBy"], ["autocomplete", "off", "maxlength", "1", 3, "id", "name", "ngModel", "disabled", "ngModelChange", "keyup", "keydown"], ["otpInput", ""]], template: function Angular7PincodeComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, Angular7PincodeComponent_input_1_Template, 2, 7, "input", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.Pin)("ngForTrackBy", ctx.trackByFn);
    } }, directives: [ɵngcc1.NgForOf, ɵngcc2.DefaultValueAccessor, ɵngcc2.MaxLengthValidator, ɵngcc2.NgControlStatus, ɵngcc2.NgModel], styles: ["\n    .otp-container{\n      width:100%;\n      text-align:left;\n    }\n    .otp-input{\n      padding: 5px;\n      margin: 0px;\n      border: 1px solid #ddd;\n      border-right: none;\n      text-align: center;\n      max-width:50px;\n    }\n    .otp-input:last-child{\n      border-right: 1px solid #ddd;\n    }\n    "], encapsulation: 2 });
/** @nocollapse */
Angular7PincodeComponent.ctorParameters = () => [];
Angular7PincodeComponent.propDecorators = {
    allOtpInputs: [{ type: ViewChildren, args: ['otpInput',] }],
    onFullFill: [{ type: Output }],
    size: [{ type: Input }],
    class: [{ type: Input }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(Angular7PincodeComponent, [{
        type: Component,
        args: [{
                selector: 'angular7-pincode',
                template: `
   <div class="otp-container">
    <input class="otp-input {{class}}" *ngFor="let pininput of Pin;let i = index;trackBy: trackByFn" id='otpInput{{i}}' #otpInput name='otpInput{{i}}' [(ngModel)]="Pin[i]" autocomplete='off' maxlength="1" [disabled]="currentIndex!=i" (keyup)="onKeyUp($event,i)" (keydown)="onKeyDown($event,i)"/>
   </div>
  `,
                encapsulation: ViewEncapsulation.None,
                styles: [`
    .otp-container{
      width:100%;
      text-align:left;
    }
    .otp-input{
      padding: 5px;
      margin: 0px;
      border: 1px solid #ddd;
      border-right: none;
      text-align: center;
      max-width:50px;
    }
    .otp-input:last-child{
      border-right: 1px solid #ddd;
    }
    `]
            }]
    }], function () { return []; }, { onFullFill: [{
            type: Output
        }], size: [{
            type: Input
        }], class: [{
            type: Input
        }], allOtpInputs: [{
            type: ViewChildren,
            args: ['otpInput']
        }] }); })();
if (false) {
    /** @type {?} */
    Angular7PincodeComponent.prototype.allOtpInputs;
    /** @type {?} */
    Angular7PincodeComponent.prototype.onFullFill;
    /** @type {?} */
    Angular7PincodeComponent.prototype.size;
    /** @type {?} */
    Angular7PincodeComponent.prototype.class;
    /** @type {?} */
    Angular7PincodeComponent.prototype.Pin;
    /** @type {?} */
    Angular7PincodeComponent.prototype.PinCode;
    /** @type {?} */
    Angular7PincodeComponent.prototype.currentIndex;
}

/**
 * @fileoverview added by tsickle
 * Generated from: lib/angular7-pincode.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class Angular7PincodeModule {
}
Angular7PincodeModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: Angular7PincodeModule });
Angular7PincodeModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function Angular7PincodeModule_Factory(t) { return new (t || Angular7PincodeModule)(); }, imports: [[CommonModule, FormsModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(Angular7PincodeModule, { declarations: function () { return [Angular7PincodeComponent]; }, imports: function () { return [CommonModule, FormsModule]; }, exports: function () { return [Angular7PincodeComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(Angular7PincodeModule, [{
        type: NgModule,
        args: [{
                declarations: [Angular7PincodeComponent],
                imports: [CommonModule, FormsModule],
                exports: [Angular7PincodeComponent]
            }]
    }], null, null); })();

/**
 * @fileoverview added by tsickle
 * Generated from: public-api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: angular7-pincode.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { Angular7PincodeComponent, Angular7PincodeModule };

//# sourceMappingURL=angular7-pincode.js.map